const statusOptions = [
    { value: "Comercialização", label: "Comercialização", },
    { value: "Esgotado", label: "Esgotado" },
    { value: "Futuro", label: "Futuro" },
    { value: "Suspenso", label: "Suspenso" },
];

const genreOptions = [
    { value: "feminino", label: "Feminino", },
    { value: "masculino", label: "Masculino", },
    { value: "outros", label: "Outros", },
    // { value: "transgênero", label: "Transgênero", },
    // { value: "gênero neutro", label: "Gênero neutro", },
];

const userTypeOptions = [
    { value: "lead", label: "Lead" },
    { value: "visitante", label: "Visitante" },
    { value: "cliente", label: "Cliente" },
];

const maritalStatusOptions = [
    { value: "casado", label: "Casado(a)" },
    { value: "divorciado", label: "Divorciado(a)" },
    { value: "separado", label: "Separado(a)" },
    { value: "solteiro", label: "Solteiro(a)" },
    { value: "viúvo", label: "Viúvo(a)" },
];

const childrenOptions = [
    { value: 1, label: 1 },
    { value: 2, label: 2 },
    { value: 3, label: 3 },
    { value: 4, label: 4 },
    { value: 5, label: "5+" }
];

const dormitorios = [1, 2, 3, 4];

const ageOptions = Array.from({ length: 82 }, (_, i) => {
    const age = i + 18;
    return {
        label: age === 99 ? "99+" : age.toString(),
        value: age
    };
});

export { statusOptions, genreOptions, userTypeOptions, maritalStatusOptions, childrenOptions, dormitorios, ageOptions };